import { ThemeConfig, extendTheme } from "@chakra-ui/react";

import { mode, StyleFunctionProps } from "@chakra-ui/theme-tools";

import { TabsComponentStyle } from "../tabs/tabs";
import { RadioComponentStyle } from "../radio/radio";
import { AvatarComponentStyle } from "../avatar/avatar";
import { ToolTipComponentStyle } from "../tooltip/tooltip";
import { CheckboxComponentStyle } from "../checkbox/checkbox";
import { InputComponentStyle } from "../input/input";
import { TextareaComponentStyle } from "../textarea/textarea";
import { PinInputComponentStyle } from "../pin-input/pin-input";
import { NumberInputComponentStyle } from "../number-input/number-input";
import { DrawerComponentStyle } from "../drawer/drawer";
import { FormControlComponentStyle } from "../form-control/form-control";
import { TableComponentStyle } from "../table/table";
import { ButtonComponentStyle } from "../button/button";
import { AlertComponentStyle } from "../alert/alert";

export const themeConfig: ThemeConfig = {
  initialColorMode: "light",
  useSystemColorMode: false
};

export const theme = extendTheme({
  breakpoints: {
    sm: "20em",
    md: "26em",
    lg: "48em",
    xl: "80em",
    "2xl": "120em"
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.88rem",
    md: "1rem",
    lg: "1.13rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.75rem",
    "4xl": "2rem",
    "5xl": "2.5rem"
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  lineHeights: {
    normal: "normal",
    none: 1,
    shorter: 1.25,
    short: 1.375,
    base: 1.5,
    tall: 1.625,
    taller: "2",
    "3": "1.28rem",
    "4": "1.30rem",
    "5": "1.33rem",
    "6": "1.36rem",
    "7": "1.52rem",
    "8": "1.58rem",
    "9": "1.61rem",
    "10": "2.5rem"
  },
  colors: {
    brand: {
      50: "#BEE3F8",
      100: "#90CDF4",
      200: "#63B3ED",
      300: "#4299E1",
      400: "#3182CE",
      500: "#2B6CB0",
      600: "#2C5282",
      700: "#2A4365",
      800: "#1A365D",
      900: "#131D47"
    },
    emoji: {
      500: "#FFCE00"
    },
    x: {
      500: "#000000",
      600: "#333333"
    },
    feedback: {
      info: "#1765C4",
      success: "#348632",
      warning: "#C55200",
      error: "#E2221D"
    }
  },
  components: {
    Tabs: TabsComponentStyle,
    Radio: RadioComponentStyle,
    Avatar: AvatarComponentStyle,
    Tooltip: ToolTipComponentStyle,
    Checkbox: CheckboxComponentStyle,
    Input: InputComponentStyle,
    Textarea: TextareaComponentStyle,
    NumberInput: NumberInputComponentStyle,
    PinInput: PinInputComponentStyle,
    Drawer: DrawerComponentStyle,
    Form: FormControlComponentStyle,
    Table: TableComponentStyle,
    Button: ButtonComponentStyle,
    Alert: AlertComponentStyle
  },
  styles: {
    global: (props: StyleFunctionProps) => ({
      body: {
        color: mode("gray.700", "whiteAlpha.900")(props)
      },
      a: {
        color: "brand.500",
        textDecoration: "underline",
        _hover: {
          textDecoration: "underline"
        },
        _focusVisible: {
          outline: "none",
          borderRadius: "md",
          boxShadow: "outline"
        }
      },
      ".ehq-participant-footer-link": {
        _hover: {
          textDecoration: "underline !important"
        }
      },
      ".chakra-alert a": {
        color: "whiteAlpha.900"
      },
      ".recharts-default-legend": {
        marginBottom: "16px !important"
      },
      ".recharts-default-legend svg": {
        borderRadius: "base"
      },
      "recharts-default-legend li": {
        verticalAlign: "middle"
      },
      ".recharts-legend-item-text": {
        color: `${mode("gray.700", "whiteAlpha.500")(props)} !important`
      },
      "*::placeholder": {
        color: mode("gray.600", "whiteAlpha.400")(props)
      },
      "*, *::before, &::after": {
        borderColor: mode("gray.500", "whiteAlpha.300")(props)
      },
      // can be changed when new toast component will be created
      ".chakra-portal .chakra-toast__inner": {
        marginBottom: { base: "80px", xl: "20px" },
        padding: "12px 16px !important",
        minWidth: { base: "288px", lg: "448px" },
        width: { base: "100%", md: "auto" }
      },
      ".chakra-portal .chakra-toast__inner button[aria-label='Close']": {
        width: "24px",
        height: "24px",
        top: "auto",
        marginRight: "4px"
      }
    })
  },
  config: themeConfig
});
